var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEksioglu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.6,29.5c-1.6,2.4-3.5,1.7-5.6,1.1,0,.9-.1,1.6-.1,2.3,0,1.1-.3,2-1.6,2.1-1.4,0-2.3-.4-2.6-1.9,0-.3-.1-.5-.1-.8.1-2.9.1-5.3-4.2-4.9-2.1.2-3.8-2.4-5.1-4.5-2.5-4.1-2.5-9-4.2-13.4-.1-.4-.2-1,0-1.3,1.5-2.4,2-5,2.1-8.2,1,.8.8,1.4.7,2-.4,2-.4,4-.2,6,.2,3,1.4,3.8,4.3,3.1,2-.5,3.6-.9,4.7,1.6.6,1.4,2.1,1.1,3.1.3,2.1-1.5,2.2-.3,2.1,1.3-.2,2.8.2,5.4,1,8.1.5,1.7,1.4,2.5,3.2,2.1,1.5-.3,2.8-.6,3.7,1.2.8,1.7-.3,2.4-1.1,3.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEksioglu);
export default __webpack_public_path__ + "static/media/eksioglu.2f80d57bc5f5bb1351b1af804ed6ade1.svg";
export { ForwardRef as ReactComponent };